import React from 'react';
import { connect } from 'react-redux';
import debounce from 'lodash/debounce';
import * as actions from '../../../actions/productData';
import {
  addToCart as addProductToCart,
  checkSelectedSize
} from '../../../actions/addProductToCart';
import { gtmAddToCart, luxeGtmAddToCart, gtmEventPushProductDetailsInteractions } from '../../../modules/ga/GTMdatalayer';
import { generateEvent } from '../../../utils/dataGrinch';
import properties from '../../../modules/ajio-util/properties';
import { setProductStoreMappingData } from '../../../refresh/utils/productStoreMappingUtils';
import { signInCheck } from '../../common/CheckUserStatus';
import luxeScreen from '../../../refresh/constants/luxeScreenType';
import { readCookie } from '../../common/Cookie';
import { jioAdsAddtoCart } from '../../../utils/jioAds';
import { showModal } from '../../../actions/modal.js';
import { getCurrentStore } from '../../../refresh/selectors/metaData';
import { getPageInfo } from '../../../utils/pageInfo';
import { getTagValueFromTagEngine, getPriceLableFromTagEngine } from '../../../utils/product';
import cleverTapPushEvent from '../../../modules/ajio-util/cleverTap/eventUtils';
import CLEVERTAP_EVENT_NAMES from '../../../modules/ajio-util/cleverTap/eventConstants';
import {
  getGiftWithProductEnable,
  getGiftWithProductConfig,
  getEnableComingSoonProducts,
  getEnableNonReturnableProductRevamp,
  getEnableNonReturnableProductRevampConfig
} from '../../../refresh/selectors/featureFlagsSelector';
import {
  getIsNonReturnable,
  getProductFnlReturnWindow
} from '../../../refresh/selectors/productpage';
import { getGAFreebiesText } from '../../common/Freebies/FreebiesCommon';
import { isCopilotReferrer } from '../../../utils/common';


const { defaultStore } = luxeScreen;
class AddToCart extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      isNotifyClicked: false,
    };
  }

  addToCart = debounce(
    imsBatchId => {
      const { selectedSizeCode = '', productData = '' } = this.props;
      let selectedSizeCodeProps = selectedSizeCode || productData;
      const { commercialType = '' } = productData;
      console.log('TRACK COMMERICAL TYPE ~ commercialType:', commercialType);
      if (imsBatchId || commercialType) {
        this.props.addProductToCart(
          selectedSizeCodeProps,
          'desktop',
          '',
          '',
          imsBatchId,
          commercialType
        );
      } else {
        this.props.addProductToCart(selectedSizeCodeProps, 'desktop');
      }
    },
    3000,
    { leading: true, trailing: false }
  );

  focusOnFirstSize = () => {
    // Wait till error text is rendered
    window.requestAnimationFrame(() => {
      const sizeGroup = document.querySelector('#size-variant-block-id');

      if (!sizeGroup) return;

      // Prefer the radio that is tabbable
      let firstRadio = sizeGroup.querySelector('[role="radio"][tabindex="0"]');

      // Fallback: first radio at all
      if (!firstRadio) {
        firstRadio = sizeGroup.querySelector('[role="radio"]');
      }

      if (firstRadio && typeof firstRadio.focus === 'function') {
        firstRadio.focus();
      }
    });
  };

  checkSelectedSize = () => {
    const { selectedSizeCode = '', productData = '' } = this.props;
    if (selectedSizeCode || Number(productData)) {
      let {
        data: {
          price: { formattedValue: Price = '', value: productPrice } = {},
          baseProduct = '',
          baseOptions = [],
          variantOptions = [],
          brickName,
          brickCategory,
          brickSubCategory,
          code: productCode,
          verticalColor
        }
      } = this.props;

      let variants = baseOptions.reduce((accumlator, item) => {
        let { variantType = '' } = item;
        if (variantType === 'FnlSizeVariant') {
          accumlator = item.options || [];
        }
        return accumlator;
      }, []);

      if (variants.length == 0 && variantOptions.length) {
        variants = variantOptions;
      }

      let sizeObj = variants.reduce((accumlator, item) => {
        let { code = '' } = item;
        if (code === selectedSizeCode || code === productData) {
          accumlator = item;
        }
        return accumlator;
      }, {});

      let {
        wasPriceData: { value: mp = 0, formattedValue: formattedMp = '' } = {},
        priceData: { value: sp = 0, formattedValue: formattedSp = '' } = {}
      } = sizeObj;

      const { variantOptionQualifiers, code } = sizeObj;
      const imsBatchId =
        (variantOptionQualifiers &&
          variantOptionQualifiers.filter(({ qualifier }, index) => qualifier === 'imsBatchId')) ||
        [];

      generateEvent({
        Event: 'AddToBag',
        value: {
          SizeSelected: selectedSizeCode || productData,
          Quantity: 1,
          Price: formattedSp,
          OriginalPrice: formattedMp,
          ProductId: baseProduct,
          Discount: `${Math.round(((mp - sp) / mp) * 100)} %`
        }
      });
      console.log('TRACK POINT 3 ~ brickSubCategory:', brickSubCategory);
      jioAdsAddtoCart({
        brickCategory,
        brickSubCategory,
        brickName,
        code: productCode,
        price: productPrice,
        quantity: 1
      });
      this.handleLuxeGtmEvents();

      if (imsBatchId && imsBatchId.length) {
        // Tell Cart component that an add-to-cart just happened
        window.dispatchEvent(new CustomEvent('cart:add-intent'));
        this.addToCart(imsBatchId[0]?.value);
      } else {
        // Tell Cart component that an add-to-cart just happened
        window.dispatchEvent(new CustomEvent('cart:add-intent'));
        this.addToCart();
      }
    } else {
      this.props.selectSizeError('Please select a size');
      this.focusOnFirstSize();
    }
  };

   notifyUserCleverTap = () => {
    let {
      data: {
        price: { formattedValue: Price = '', value: productPrice } = {},
        baseProduct = '',
        baseOptions = [],
        variantOptions = [],
        brickName,
        name,
        brandName,
        styleType,
        brickCategory,
        brickSubCategory,
        code: productCode,
        verticalColor,
        code,
        selectedSizeName=''
      }
    } = this.props;
    const userId = decodeURIComponent(readCookie('U')) || '';
    const event_payload = {
      eventName: CLEVERTAP_EVENT_NAMES.Notify_Me,
      eventObj: {
        product_id: productCode,
        product_name: name,
        brick_name: brickName,
        segment_name: styleType,
        Brand_name: brandName,
        MRP: this.props?.data?.price?.formattedValue,
        platform: 'WEB',
      }
    }
    cleverTapPushEvent(event_payload);
  };

  componentDidMount() {
    this.checkAndShowNotification();
  }

  checkAndShowNotification() {
    const redirectBack = localStorage.getItem('notifyPrdCode');
    const username = signInCheck();
    if (redirectBack && username) {
      let prodDataVal = this.props?.productData || '';
      let brandName = this.props?.data?.brandName || '';
      let brickCategory = this.props?.data?.brickCategory || '';
      gtmEventPushProductDetailsInteractions(
        'notification cta click',
        'successful/failure',
        prodDataVal,
        '',
        brandName,
        '',
        brickCategory,
      );
      this.notifyUserCleverTap()
      this.props.selectNotifyError("Get ready! we'll notify via registered email");
      localStorage.removeItem('notifyPrdCode');
      this.setState({ isNotifyClicked: true });
    }
  }

  addToNotify = () => {
    const prodUrl = this.props?.data?.url || '';
    const username = signInCheck();
    const redirectBack = localStorage.getItem('notifyPrdCode');
    if (username) {
      let prodDataVal = this.props?.productData || '';
      let brandName = this.props?.data?.brandName || '';
      let brickCategory = this.props?.data?.brickCategory || '';
      gtmEventPushProductDetailsInteractions(
        'notification cta click',
        'successful/failure',
        prodDataVal,
        '',
        brandName,
        '',
        brickCategory,
      );
      const { selectedSizeCode = '', productData = '' } = this.props;
      const oosCheck = this.props.data.stock.stockLevel;
    if (selectedSizeCode || Number(productData) || Number(oosCheck) === 0) {
      this.notifyUserCleverTap()
      if (this.state.isNotifyClicked) {
        this.props.selectNotifyError("Already on it! We'll let you know");
      }
      else {
        this.props.selectNotifyError("Get ready! we'll notify via registered email");
        gtmEventPushProductDetailsInteractions(
          'notification cta click',
          "Get ready! we'll notify via registered email",
          prodDataVal,
          '',
          brandName,
          '',
          brickCategory,

        );
        this.setState({ isNotifyClicked: true });

      }
    } else {
      this.props.selectNotifyError('Plese select size to get notified');
    }
  }
  else{
    localStorage.setItem('notifyPrdCode', this.props?.data?.baseProduct);
    this.props.showModal('sign-in-up');
  }
}


  handleLuxeGtmEvents = () => {
    const { location: { pathname = '' } = {} } = window;
    const { pageType: pageListType } = getPageInfo(pathname);

    let {
      data: {
        baseProduct: productCode = '',
        brickCategory,
        brandName,
        brickName,
        brickCode,
        fnlColorVariantData: { color: productColor = '', productTag = '', exclusiveTill = '' } = {},
        price: {
          discountPercentage = '',
          discountPercent = '',
          segmentId = '',
          experimentId = '',
          value
        } = {},
        wasPriceData: { value: price = '' } = {},
        name,
        catalog,
        tagResponse: { tag: { categoryTags = [] } = {} } = {}
      } = {},
      productData,
      selectedSizeCode,
      selectedSizeName,
      newDesignLuxe,
      currentStore,
      averageRating,
      numUserRatings,
      enableGiftWithProduct,
      giftWithProductConfig,
      freebiesItemsCount,
      returnWindow,
      isNonReturnable,
      enableNonReturnableProductRevamp
    } = this.props;

    const productTagEngineValue = getTagValueFromTagEngine(categoryTags);
    let productPriceLabel = getPriceLableFromTagEngine(categoryTags);

    const freebiesText = `GetFreebies - ${freebiesItemsCount}`;

    if (enableGiftWithProduct && freebiesItemsCount > 0) {
      productPriceLabel = productPriceLabel ? `${productPriceLabel}, ${freebiesText}` : `${freebiesText}`
    }

    const product_tag = exclusiveTill ? 'EXCLUSIVE' : productTag;

    let copilotSource = false;
    if(isCopilotReferrer()){
      copilotSource = true
    }
    if (newDesignLuxe) {
      luxeGtmAddToCart(
        name,
        productCode,
        value,
        brandName,
        brickCategory,
        selectedSizeName,
        productColor,
        discountPercentage,
        brickName,
        product_tag,
        '1',
        'pdp screen',
        'luxe',
        'pdp screen',
        'pdp screen',
        'pdp screen',
        'luxe',
        true,
        catalog,
        segmentId,
        experimentId,
        price,
        '',
        productPriceLabel,
        '',
        '',
        selectedSizeCode,
        copilotSource,
        {},
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        brickCode,
        returnWindow ?? 0,
        isNonReturnable,
        enableNonReturnableProductRevamp
      );
    } else {
      let variant = productData?.split('_')[1] || '';
      gtmAddToCart(
        productCode,
        name,
        price,
        brandName,
        brickCategory,
        variant,
        '1',
        discountPercent,
        selectedSizeName,
        currentStore === '' ? 'Ajio' : currentStore,
        'pdp screen',
        productData,
        productTagEngineValue,
        productPriceLabel,
        averageRating,
        numUserRatings,
        catalog,
        segmentId,
        experimentId,
        '',
        price,
        value,
        '',
        '',
        selectedSizeCode,
        copilotSource,
        {},
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        brickCode,
        returnWindow ?? 0,
        isNonReturnable,
        enableNonReturnableProductRevamp
      );
    }
  };

  render() {
    const prodData = this.props.productData;
    const {isComingSoonEnabled} = this.props
    const { brandName } = this.props.data.brandName
    const { brickCategory } = this.props.data.brickCategory
    const { isComingSoonProduct } = this.props.data;
    const productUrl = this.props.data.url;
    const {
      oosStatus,
      selectedSizeCode,
      trustMarkerTxt,
      enableNonReturnableProductRevamp,
      nonReturnableProductRevampConfig,
      isNonReturnable,
      addedToCart
    } = this.props;
    const nonReturnableText =
      nonReturnableProductRevampConfig?.nonReturnableDesktop || '(Non Returnable)';
    const newDesignLuxe = this.props.newDesignLuxe;
    const showNonReturnableText =
      enableNonReturnableProductRevamp &&
      isNonReturnable &&
      !addedToCart &&
      !oosStatus.includes(selectedSizeCode);
    let userLogin = signInCheck();
    if (this.props.addedToCart && userLogin) {
      const itemCode = prodData.split('_')[0] || '';
      const userId = decodeURIComponent(readCookie('CI')) || '';
      setProductStoreMappingData(userId, itemCode, newDesignLuxe ? 'luxe' : defaultStore);
    }
    return (
      <div className={newDesignLuxe ? 'pdp-cart' : null}>
        <div
          className="pdp-addtocart-button"
        >
          {this.props.addedToCart ? (
            <a
              href={!newDesignLuxe ? `${properties.getProperty('parentUrl')}/cart` : '/cart'}
              className={`go-to-cart-btn ${newDesignLuxe ? 'btn-dark' : ''}`}
            >
              <div className={`btn-cart ${newDesignLuxe ? 'btn-dark' : ''}`}>
                <span className="ic-pdp-add-cart" />
                <span aria-label={newDesignLuxe ? 'GO TO CART' : 'GO TO BAG'}>
                  {newDesignLuxe ? 'GO TO CART' : 'GO TO BAG'}
                </span>
              </div>
            </a>
          ) : isComingSoonEnabled ? (
            isComingSoonProduct ? (
              <div
                className={newDesignLuxe ? 'btn-gold btn-dark notiffy_me' : 'btn-gold notiffy_me'}
                onClick={() => {
                  this.addToNotify();
                }}
                role="button"
                tabIndex={0}
              >
                <img
                  src={`${properties.getProperty('imageBaseUrl')}/static/img/notiffy_bell.svg`}
                  style={{ marginRight: '8px', marginBottom: '5px' }}
                  alt={''}
                />
                <span aria-label={newDesignLuxe ? 'NOTIFY ME' : 'NOTIFY ME'}>
                  {newDesignLuxe ? 'NOTIFY ME' : 'NOTIFY ME'}
                </span>
              </div>
            ) : oosStatus.includes(selectedSizeCode) ? (
              <div className="product-oos-block">
                {!newDesignLuxe && (
                  <div
                    className="oos-item-unavailable"
                    aria-label="You just missed it. This size is currently out of stock."
                  >
                    You just missed it. This size is currently out of stock.
                  </div>
                )}
                <div className="oos-heading" aria-label="OUT OF STOCK!">
                  <span className="ic-pdp-oos" />
                  &nbsp;OUT OF STOCK!
                </div>
              </div>
            ) : (
              <div
                className={`${newDesignLuxe ? 'btn-gold btn-dark' : 'btn-gold'}${
                  showNonReturnableText ? ' btn-non-returnable' : ''
                }`}
                onClick={() => {
                  this.checkSelectedSize();
                }}
                role="button"
                tabIndex={0}
              >
                <span className="ic-pdp-add-cart" />
                {newDesignLuxe && showNonReturnableText ? (
                  <div className="btn-non-returnable-text-wrapper">
                    <span aria-label={newDesignLuxe ? 'ADD TO CART' : 'ADD TO BAG'}>
                      {newDesignLuxe ? 'ADD TO CART' : 'ADD TO BAG'}
                    </span>
                    <span className="non-returnable-text">{nonReturnableText}</span>
                  </div>
                ) : (
                  <span aria-label={newDesignLuxe ? 'ADD TO CART' : 'ADD TO BAG'}>
                    {newDesignLuxe ? 'ADD TO CART' : 'ADD TO BAG'}
                  </span>
                )}
                {!newDesignLuxe && showNonReturnableText && (
                  <span className="non-returnable-text">{nonReturnableText}</span>
                )}
              </div>
            )
          ) : oosStatus.includes(selectedSizeCode) ? (
            <div className="product-oos-block">
              {!newDesignLuxe && (
                <div
                  className="oos-item-unavailable"
                  aria-label="You just missed it. This size is currently out of stock."
                >
                  You just missed it. This size is currently out of stock.
                </div>
              )}
              <div className="oos-heading" aria-label="OUT OF STOCK!">
                <span className="ic-pdp-oos" />
                &nbsp;OUT OF STOCK!
              </div>
            </div>
          ) : (
            <div
              className={`${newDesignLuxe ? 'btn-gold btn-dark' : 'btn-gold'}${
                showNonReturnableText ? ' btn-non-returnable' : ''
              }`}
              onClick={() => {
                this.checkSelectedSize();
              }}
              role="button"
              tabIndex={0}
            >
              <span className="ic-pdp-add-cart" />
              {newDesignLuxe && showNonReturnableText ? (
                <div className="btn-non-returnable-text-wrapper">
                  <span aria-label={newDesignLuxe ? 'ADD TO CART' : 'ADD TO BAG'}>
                    {newDesignLuxe ? 'ADD TO CART' : 'ADD TO BAG'}
                  </span>
                  <span className="non-returnable-text">{nonReturnableText}</span>
                </div>
              ) : (
                <span aria-label={newDesignLuxe ? 'ADD TO CART' : 'ADD TO BAG'}>
                  {newDesignLuxe ? 'ADD TO CART' : 'ADD TO BAG'}
                </span>
              )}
              {!newDesignLuxe && showNonReturnableText && (
                <span className="non-returnable-text">{nonReturnableText}</span>
              )}
            </div>
          )}
        </div>
        <div
          className="pdp-prod-tips"
          aria-label={trustMarkerTxt || 'HANDPICKED STYLES | ASSURED QUALITY '}
        >
          {trustMarkerTxt || 'HANDPICKED STYLES | ASSURED QUALITY '}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    selectedSizeCode: state.product.selectedSizeCode,
    addedToCart: state.popup.addedToCart,
    oosStatus: state.cart.oosStatus || [],
    currentStore: getCurrentStore(state),
    enableGiftWithProduct: getGiftWithProductEnable(state.flags),
    giftWithProductConfig: getGiftWithProductConfig(state),
    isComingSoonEnabled: getEnableComingSoonProducts(state?.flags),
    enableNonReturnableProductRevamp: getEnableNonReturnableProductRevamp(state),
    nonReturnableProductRevampConfig: getEnableNonReturnableProductRevampConfig(state),
    isNonReturnable: getIsNonReturnable(state),
    returnWindow: getProductFnlReturnWindow(state)
  };
};

const mapDispatchToProps = dispatch => {
  return {
    addProductToCart: (
      productId,
      deviceType,
      isRecursivelyCalling,
      successCallback,
      imsBatchId,
      commercialType
    ) =>
      dispatch(
        addProductToCart(
          productId,
          deviceType,
          isRecursivelyCalling,
          successCallback,
          imsBatchId,
          commercialType
        )
      ),
    selectSizeError: message => dispatch(actions.selectSizeError(message)),
    showModal: name => {
      dispatch(showModal(name));
    },
    selectNotifyError: message => dispatch(actions.selectNotifyError(message)),
    checkSelectedSize: (data, selectedSizeCode) =>
      dispatch(checkSelectedSize(data, selectedSizeCode))
  };
};

export default AddToCart = connect(mapStateToProps, mapDispatchToProps)(AddToCart);
